import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginBottom: theme.spacing(1),
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    width: theme.spacing(12),
    height: "fit-content",
  },
  orgIconContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "start",
  },
  orgText: {
    flexDirection: "column",
    marginLeft: theme.spacing(2.5),
    [theme.breakpoints.down("md")]: {
      marginLeft: 0,
    },
  },
  text: {
    textWrap: "wrap",
  },
  membersTextContainer: {
    display: "flex",
    alignItems: "center",
  },
  actionButton: {
    color: "white",
    display: "flex",
    justifyContent: "space-evenly",
    padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
    backgroundColor: theme.palette.success.contrastText,
    borderRadius: theme.spacing(1),
    textTransform: "uppercase",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    marginBottom: theme.spacing(0.5),
  },
}));

export default useStyles;
